import React, { useEffect } from "react";

const LoginLayout = ({ children }) => {
    useEffect(() => {
        // Dynamically add the required CSS files from the public directory
        const addStylesheet = (href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = `${process.env.PUBLIC_URL}${href}`;
            document.head.appendChild(link);
            return link;
        };

        const stylesheets = [
            "/auth/vendor/bootstrap/css/bootstrap.css",
            "/auth/fonts/font-awesome-4.7.0/css/font-awesome.min.css",
            "/auth/fonts/iconic/css/material-design-iconic-font.min.css",
            "/auth/vendor/animate/animate.css",
            "/auth/vendor/css-hamburgers/hamburgers.min.css",
            "/auth/vendor/animsition/css/animsition.min.css",
            "/auth/vendor/select2/select2.min.css",
            "/auth/css/util.css",
            "/auth/css/main.css",
        ];

        const links = stylesheets.map(addStylesheet);

        // Clean up on component unmount
        return () => {
            links.forEach((link) => {
                document.head.removeChild(link);
            });
        };
    }, []);

    return (
        <div className="limiter">
            <div className="container-login100">
                <div className="wrap-login100">{children}</div>
            </div>
        </div>
    );
};

export default LoginLayout;